import DispatcherAddRequest, {
  DispatcherAddRequestBody,
} from "./dispatcher-add.request";

const createBody = (data: DispatcherAddRequest): DispatcherAddRequestBody => {
  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    mobilePrimary: data.mobilePrimary,
    mobilePrimaryPrefix: data.mobilePrimaryPrefix,
    mobileSecondary: data.mobileSecondary,
    mobileSecondaryPrefix: data.mobileSecondaryPrefix,
    password: data.password,
    username: data.username,
    dispatcher: {
      dispatchId: data.dispatchId,
    },
  };
};

const dispatcherAddRequestFactory = {
  createBody,
};

export default dispatcherAddRequestFactory;
